import { cancelAnimation, runOnUI, withSequence, withSpring, withTiming, type SharedValue } from 'react-native-reanimated';
import { isRTL } from '../../../shared/i18n/rtl';

export const MENU_CARD_IMAGE_SECTION_WIDTH = 142;

export type MenuCardTapRegion = 'image' | 'content';

export type ResolvedMenuCardTap = {
  region: MenuCardTapRegion;
  direction: 'left' | 'right';
};

/**
 * Map a card-local touch X to image vs content and left/right intent.
 * Image is at the layout start in LTR and layout end in RTL (`row` mirror).
 */
export function resolveMenuFlowCardTap(
  touch_x: number,
  full_width: number,
  content_width: number,
  is_rtl: boolean = isRTL(),
): ResolvedMenuCardTap {
  const rtl = is_rtl === true;
  const image_at_start = !rtl;
  const in_image = image_at_start
    ? touch_x < MENU_CARD_IMAGE_SECTION_WIDTH
    : full_width > 0 && touch_x > full_width - MENU_CARD_IMAGE_SECTION_WIDTH;

  if (in_image) {
    return { region: 'image', direction: 'right' };
  }

  let relative_x: number;
  if (image_at_start) {
    relative_x = Math.max(0, touch_x - MENU_CARD_IMAGE_SECTION_WIDTH);
  } else {
    relative_x = Math.max(0, full_width - MENU_CARD_IMAGE_SECTION_WIDTH - touch_x);
  }

  const direction = relative_x < content_width / 3 ? 'left' : 'right';
  return { region: 'content', direction };
}

const PULSE_SPRING = { stiffness: 380, damping: 32, mass: 0.5 };

export function pulseMenuCardImagePress(image_press_scale: SharedValue<number>): void {
  runOnUI(() => {
    'worklet';
    cancelAnimation(image_press_scale);
    image_press_scale.value = withSequence(withTiming(0.98, { duration: 55 }), withSpring(1, PULSE_SPRING));
  })();
}
